export const PAGE_CONFIG = {
  "name": "CommonLogWrap",
  "config": {
    "logConfig": {
      "menuId": "",
      "pageId": "101701",
      "pageName": "studio首页",
      "extInfo": "首页-studio-home",
      "pagePath": "/home"
    }
  },
  "children": [
    {
      "name": "Service",
      "className": "",
      "type": "view",
      "style": {},
      "data": {
        "refreshTimestamp": 0
      },
      "props": {
        "api": "/api/v2/dashboard/studio/intelligence/report_list",
        "dataKey": "reportList",
        "filterLoading": false,
        "trackData": [
          "frameCode",
          "refreshTimestamp"
        ],
        "beforeRequest": "function(data) {\n                    return {\n                        systems: [\n                            'intelligence',\n                            'intelligence_insights',\n                            'gameResearch',\n                            'intelligence_ai',\n                        ],\n                        studio_code: (data === null || data === void 0 ? void 0 : data.frameCode),\n                        sorted_by: 'create_time',\n                        desc: true,\n                        category: 'selected',\n                    };\n                }",
        "formatData": "function(data) {\n    if (data === null || data === void 0 ? void 0 : data.resource_list) {\n        data.resource_list = data.resource_list.filter(function(item) {\n            var reportLanguageEn = item === null || item === void 0 ? void 0 : item.report_language_en;\n            var reportLanguage = item === null || item === void 0 ? void 0 : item.report_language;\n\n            var isEnglishInReportLanguageEn = typeof reportLanguageEn === 'string'\n                && reportLanguageEn.toLowerCase().includes('english');\n\n            var isEnglishInReportLanguage = typeof reportLanguage === 'string'\n                && reportLanguage.toLowerCase().includes('english');\n\n            return isEnglishInReportLanguageEn || isEnglishInReportLanguage;\n        });\n    }\n\n    return data;\n}"
      },
      "children": [
        {
          "name": "IntelligenceReports",
          "props": {
            "titleEn": "Selected Report",
            "titleCn": "已选报告",
            "tabOption": {
              "defaultValue": "all",
              "tabOptions": [
                {
                  "value": "all",
                  "enName": "All Reports",
                  "cnName": "全部报告"
                },
                {
                  "value": "intelligence",
                  "enName": "Market Reports",
                  "cnName": "市场报告"
                },
                {
                  "value": "intelligence_insights",
                  "enName": "Insights Reports",
                  "cnName": "洞察报告"
                },
                {
                  "value": "gameResearch",
                  "enName": "GRC Reports",
                  "cnName": "游戏研究报告"
                },
                {
                  "value": "intelligence_ai",
                  "enName": "AI Reports",
                  "cnName": "AI报告"
                }
              ]
            },
            "editModalConfig": {
              "titleEn": "Edit Reports",
              "titleCn": "编辑报告",
              "leftTitleEn": "All Reports",
              "leftTitleCn": "全部报告",
              "rightInfoEn": "Expired reports will be automatically removed",
              "rightInfoCn": "过期报告将自动移除",
              "searchPlaceholderEn": "Search Report",
              "searchPlaceholderCn": "搜索报告",
              "defaultSortByCreateTime": true,
              "haveTopDateFilter": true,
              "topDateFilterLabelEn": "Batch Date Range",
              "topDateFilterLabelCn": "批量选择展示日期范围",
              "extraToolList": ['bulletedList'],
              "summaryExpandable": true
            },
            "pagination": {
              "pageSize": 10,
              "pageSizeOptions": [
                10,
                20,
                30,
                40,
                50
              ]
            },
            "category": "selected",
            "enableEditNotes": true
          }
        }
      ]
    }
  ]
};
